import React from "react";

const InformationText = () => {
  return (
    <div className="card border-0 shadow-sm rounded-4 mb-4">
      <div className="card-body p-4 p-md-5">
        <h5 className="card-title fw-bold mb-4">Bilgilendirme Metni</h5>
        <div className="p-3 bg-light rounded-3">
          <p className="mb-0 text-muted">
            Bu metin daha sonra eklenecektir. Burada kullanıcı iletişim tercihleri ile ilgili yasal bilgilendirme yer alacaktır.
          </p>
        </div>
      </div>
    </div>
  );
};

export default InformationText;
